import { useEffect, useState } from "react";
import {
  useGetInfoQuery,
  useSendAnalyticsFunnelMutation,
  useSendFacebookEventMutation,
} from "../api/dataApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import ReactPixel from "react-facebook-pixel";
import axios from "axios";
import mixpanel from "mixpanel-browser";
import Cookies from "js-cookie";

const useFaceBook = () => {
  const history = useHistory();
  const { data: userInfo } = useGetInfoQuery();
  const [sendFacebookEvent] = useSendFacebookEventMutation();
  const [sendAnalyticsFunnel] = useSendAnalyticsFunnelMutation();

  const excludedKeys = new Set([
    "an_site",
    "an_plc",
    "an_net",
    "an_ad",
    "an_grp",
    "an_cam",
    "an_acc",
    "utm_term",
    "utm_content",
    "visitor_id",
    "utm_campaign",
    "utm_medium",
    "utm_source",
    "fbclid",
    "utm_source_platform",
    "gclid",
    "ttclid",
    "wbraid",
    "fclid",
    "gcid",
    "tclid",
    "wbid",
  ]);

  function getFBP() {
    const name = "_fbp=";
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  function getFBC() {
    const name = "_fbc=";
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  const fbp = getFBP();
  const fbc = getFBC();

  function readCachedGeo() {
    try {
      return JSON.parse(localStorage.getItem("geo_info") || "null");
    } catch {
      return null;
    }
  }

  function isGeoPresent(geoLike) {
    return Boolean(geoLike?.country_code || geoLike?.region || geoLike?.city);
  }

  function getLatestGeo(geoState) {
    return isGeoPresent(geoState) ? geoState : readCachedGeo();
  }

  const [geo, setGeo] = useState({
    country_code: null,
    region: null,
    city: null,
  });

  useEffect(() => {
    // Fetch Geo (IP will be determined on backend)

    let skipGeo = false;
    try {
      const cached = JSON.parse(localStorage.getItem("geo_info") || "null");
      if (cached && (cached.country_code || cached.region || cached.city)) {
        setGeo(cached);
        skipGeo = true;
      }
    } catch (err) {
      console.error("geo_info cache parse error", err);
    }

    const geoController = new AbortController();
    const fetchGeo = async () => {
      if (skipGeo) return;
      try {
        const res = await fetch("https://ipapi.co/json/", {
          signal: geoController.signal,
        });
        if (res.ok) {
          const data = await res.json();
          const nextGeo = {
            country_code: data?.country_code || data?.country || null,
            region: data?.region || data?.region_code || null,
            city: data?.city || null,
          };
          setGeo(nextGeo);
          localStorage.setItem("geo_info", JSON.stringify(nextGeo));
          return;
        } else {
          console.error("ipapi.co non-ok response", res.status, res.statusText);
        }
      } catch (err) {
        if (err?.name !== "AbortError") {
          console.error("ipapi.co fetch error", err);
        }
      }

      try {
        const res2 = await fetch("https://ipinfo.io/json", {
          signal: geoController.signal,
        });
        if (res2.ok) {
          const data2 = await res2.json();
          const nextGeo = {
            country_code: data2?.country || null,
            region: data2?.region || null,
            city: data2?.city || null,
          };
          setGeo(nextGeo);
          localStorage.setItem("geo_info", JSON.stringify(nextGeo));
          return;
        } else {
          console.error(
            "ipinfo.io non-ok response",
            res2.status,
            res2.statusText,
          );
        }
      } catch (err) {
        if (err?.name !== "AbortError") {
          console.error("ipinfo.io fetch error", err);
        }
      }
    };
    fetchGeo();

    return () => {
      geoController.abort();
    };
  }, []);

  const pathname = history?.location?.pathname;

  const storageKey = `eventId_${pathname}`;
  let eventId = localStorage.getItem(storageKey);
  if (!eventId) {
    eventId = `event_${Date.now()}_${Math.random().toString(36).substring(2)}`;
    localStorage.setItem(storageKey, eventId);
  }

  const sendFb = (eventName, data, dataPixel, googleData, bqData) => {
    const pathname = history?.location?.pathname;
    const fullJSON = localStorage.getItem("business-profiles");
    const profile = JSON.parse(fullJSON)?.[0];

    const processedOrderIdsKey = "processedOrderIds";
    let processedOrderIds = JSON.parse(
      sessionStorage.getItem(processedOrderIdsKey) || "[]",
    );
    if (googleData?.orderId && processedOrderIds.includes(googleData.orderId)) {
      return;
    }
    if (googleData?.orderId) {
      processedOrderIds.push(googleData.orderId);
      sessionStorage.setItem(
        processedOrderIdsKey,
        JSON.stringify(processedOrderIds),
      );
    }

    const dataFB = {
      clineUserAgent: navigator.userAgent,
      websiteUrl: window.location.href,

      path: pathname,
      ...(localStorage.getItem("email") && {
        email: localStorage.getItem("email"),
      }),
      ...(profile?.userName && { name: profile?.userName }),
      ...(fbp && { fbp: fbp }),
      ...(fbc
        ? { fbc: fbc }
        : Cookies.get("fbclid")
          ? { fbclid: Cookies.get("fbclid") }
          : {}),
      ...(userInfo?.data?.id ? { externalId: userInfo?.data?.id } : {}),
      ...(localStorage.getItem("testevent") && {
        testEvent: localStorage.getItem("testevent"),
      }),
    };

    const queryParams = new URLSearchParams(window.location.search);
    const formData = {};

    queryParams.forEach((value, key) => {
      if (value && !excludedKeys.has(key)) {
        formData[key] = value;
      }
    });

    const getParam = (cookieKey, queryKey) => {
      const queryVal = queryParams.get(queryKey);
      return queryVal || null;
    };

    // UTM parameters are only read from URL, not from cookies
    const getUtmParam = (queryKey) => {
      return queryParams.get(queryKey) || null;
    };

    const urlVisitorId = queryParams.get("visitor_id");
    const cookieVisitorId = Cookies.get("visitor_id");
    let visitorId = urlVisitorId || cookieVisitorId || crypto.randomUUID();

    // source_visitor_id: if visitor_id changed, save old one
    let sourceVisitorId = null;
    if (urlVisitorId && cookieVisitorId && urlVisitorId !== cookieVisitorId) {
      sourceVisitorId = cookieVisitorId;
    } else {
      // Also check if source_visitor_id was set in index.js
      sourceVisitorId =
        Cookies.get("source_visitor_id") ||
        window.__SOURCE_VISITOR_ID__ ||
        null;
    }

    Cookies.set("visitor_id", visitorId, { expires: 365 });

    const dataFunnel = {
      ...(visitorId && {
        visitor_id: visitorId,
      }),
      ...(sourceVisitorId && {
        source_visitor_id: sourceVisitorId,
      }),
      ...(geo?.country_code && { country_code: geo.country_code }),
      ...(geo?.region && { region: geo.region }),
      ...(geo?.city && { city: geo.city }),
      ...(localStorage.getItem("userId") && {
        user_id: localStorage.getItem("userId"),
      }),

      ...(eventName && { event_name: eventName }),
      ...(window.location.hostname && { hostname: window.location.hostname }),
      ...(window.location.pathname && { page: window.location.pathname }),
      ...(() => {
        const clid =
          queryParams.get("fbclid") ||
          queryParams.get("fclid") ||
          queryParams.get("gclid") ||
          queryParams.get("gcid") ||
          queryParams.get("ttclid") ||
          queryParams.get("tclid") ||
          queryParams.get("wbraid") ||
          queryParams.get("wbid");
        return clid ? { clid } : {};
      })(),
      device_platform: "web",
      ...(window.location.href && { page_url: window.location.href }),
      ...(document.referrer && { referrer_url: document.referrer }),
      ...(navigator.userAgent && { user_agent: navigator.userAgent }),
      ...(getUtmParam("utm_source") && {
        utm_source: getUtmParam("utm_source"),
      }),
      ...(getUtmParam("utm_campaign") && {
        utm_campaign: getUtmParam("utm_campaign"),
      }),
      ...(getUtmParam("utm_medium") && {
        utm_medium: getUtmParam("utm_medium"),
      }),
      ...(getUtmParam("utm_content") && {
        utm_content: getUtmParam("utm_content"),
      }),
      ...(getUtmParam("utm_term") && {
        utm_term: getUtmParam("utm_term"),
      }),
      ...(getUtmParam("utm_source_platform") && {
        utm_source_platform: getUtmParam("utm_source_platform"),
      }),
      ...(getParam("an_acc", "an_acc") && {
        an_acc: getParam("an_acc", "an_acc"),
      }),
      ...(getParam("an_cam", "an_cam") && {
        an_cam: getParam("an_cam", "an_cam"),
      }),
      ...(getParam("an_grp", "an_grp") && {
        an_grp: getParam("an_grp", "an_grp"),
      }),
      ...(getParam("an_ad", "an_ad") && { an_ad: getParam("an_ad", "an_ad") }),
      ...(getParam("an_net", "an_net") && {
        an_net: getParam("an_net", "an_net"),
      }),
      ...(getParam("an_plc", "an_plc") && {
        an_plc: getParam("an_plc", "an_plc"),
      }),
      ...(getParam("an_site", "an_site") && {
        an_site: getParam("an_site", "an_site"),
      }),
      ...(googleData?.orderId && { order_id: googleData?.orderId }),
      ...(Date.now() && { timestamp: Date.now() }),
      // ...(navigator.language && { language: navigator.language }),
      ...(formData && {
        data: formData,
      }),

      ...bqData,
    };

    const storageKey = `sentEvents_${pathname}`;

    const sentEvents = JSON.parse(sessionStorage.getItem(storageKey) || "[]");

    const scheduleFunnel = () => {
      const deadline = Date.now() + 5000;
      const tick = () => {
        const latestGeo = getLatestGeo(geo);
        const ready = isGeoPresent(latestGeo);

        const finalFunnel = {
          ...dataFunnel,
          ...(latestGeo?.country_code && {
            country_code: latestGeo.country_code,
          }),
          ...(latestGeo?.region && { region: latestGeo.region }),
          ...(latestGeo?.city && { city: latestGeo.city }),
        };

        if (ready || Date.now() >= deadline) {
          sendAnalyticsFunnel(finalFunnel);
        } else {
          setTimeout(tick, 250);
        }
      };
      tick();
    };

    scheduleFunnel();

    if (sentEvents.includes(eventName) && data?.onlyBq !== true) {
      return;
    }

    const newEventId = `event${Date.now()}${Math.random()
      .toString(36)
      .substring(2)}`;

    if (window.fbq) {
      window.fbq(
        "track",
        eventName,
        {
          ...(userInfo?.data?.id ? { external_id: userInfo?.data?.id } : {}),
          ...dataPixel,
        },
        {
          eventID: newEventId,
        },
      );
    }

    const excludedEvents = [
      "PageView",
      "purchase_upsell",
      "upsell_show",
      "upsell_pass",
      "upsell_skip",
      "purchase_upsell_error",
      "pricing_click",
      "pricing_pass",
      "pricing_show",
      "info_button_click",
      "autologin_token_requested",
      "autologin_token_received",
      "autologin_token_request_failed",
      "checkout_show",
      "checkout_click",
      "purchase_error",
      "autologin_link_composed",
      "booster_error_skip",
    ];

    if (!excludedEvents.includes(eventName)) {
      sendFacebookEvent({
        pixelId: "507395697701950",
        eventName: eventName,
        userId: userInfo?.data?.id,
        eventId: newEventId,
        ...dataFB,
        ...data,
      });
    }

    if (eventName === "Purchase") {
      const formdata = new FormData();

      // UTM parameters are only read from URL, not from mixpanel properties
      const urlParams = new URLSearchParams(window.location.search);
      const utmSource = urlParams.get("utm_source") || "";
      const utmMedium = urlParams.get("utm_medium") || "";
      const utmCampaign = urlParams.get("utm_campaign") || "";
      const utmContent = urlParams.get("utm_content") || "";
      const utmTerm = urlParams.get("utm_term") || "";

      formdata.append(
        "domen",
        window.location.hostname + process.env.REACT_APP_BASENAME,
      );
      formdata.append("eventName", eventName);
      formdata.append("eventId", newEventId);
      formdata.append("userId", userInfo?.data?.id);
      formdata.append("email", localStorage.getItem("email"));
      formdata.append("pixelId", "507395697701950");
      formdata.append("fbp", fbp);
      formdata.append("fbc", fbc);
      formdata.append(
        "pixelData",
        JSON.stringify({
          ...(userInfo?.data?.id ? { external_id: userInfo?.data?.id } : {}),
          ...dataPixel,
          eventID: newEventId,
        }),
      );
      formdata.append(
        "capiData",
        JSON.stringify({
          pixelId: "507395697701950",
          eventName: eventName,
          userId: userInfo?.data?.id,
          eventId: newEventId,
          ...dataFB,
          ...data,
        }),
      );
      formdata.append("utmSource", utmSource);
      formdata.append("utmMedium", utmMedium);
      formdata.append("utmCampaign", utmCampaign);
      formdata.append("utmContent", utmContent);
      formdata.append("utmTerm", utmTerm);
      formdata.append("orderId", googleData?.orderId);
      sendData(formdata);
    }

    sentEvents.push(eventName);
    sessionStorage.setItem(storageKey, JSON.stringify(sentEvents));
  };

  return { sendFb };
};

const sendData = async (formdata) => {
  try {
    const response = await axios.post(
      "https://zee.sale/facebook-event.php",
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    console.log(response.data);
  } catch (error) {
    console.error(error);
  }
};

export default useFaceBook;
